import { parse, parseISO, format } from 'date-fns';

/**
 * The order is from the point of view of the data entering the frontend from the backend.
 * 1. Is conversion from Server JSON into Client Data
 * 2. Is conversion from Client Data into Client Representation
 * 3. Is conversion from Client Representation into Client Data
 * 4. Is conversion from Client Data into Server JSON
 */

/**
 * 1. Transform a string in ISO8601 with TZ format into a Date object
 *    Example input: "2023-05-10T20:00:00+02:00"
 */
export function parseIso8601WithTZ(isoString: string): Date {
  return parseISO(isoString);
}

/**
 * 2. Transform a Date object into a string in the format "dd-MM-yyyy HH:mm" (local time)
 *    Example output: "10-05-2023 20:00"
 */
export function formatDateToLocalString(date: Date): string {
  return format(date, 'dd-MM-yyyy HH:mm');
}

/**
 * 3. Transform a string in the format "dd-MM-yyyy HH:mm" into a Date object (missing seconds are set to 0)
 *    Assume the string is in the local time.
 *    Example input: "10-05-2023 20:00"
 */
export function parseLocalStringToDate(dateString: string): Date {
  // The "new Date()" here serves as a base reference date
  return parse(dateString, 'dd-MM-yyyy HH:mm', new Date());
}

/**
 * 4. Transform a Date object into an ISO8601 string with timezone, e.g. "2023-05-10T20:00:00+02:00"
 */
export function formatDateToIsoWithTZ(date: Date): string {
  // Using the custom pattern to ensure timezone offset is included
  // You could also use formatISO(date) directly if you prefer that default format
  return format(date, "yyyy-MM-dd'T'HH:mm:ssxxx");
}
